
import { DynamicParameter, InsightDetails, Operator } from "@/types/insights"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { Getter } from "vuex-class"
import Guid from "@/scripts/guid"

import vSelect from "vue-select"
import ParameterValue from "../Controls/ParameterValue.vue"

import { dataTypeParameters, DataType } from "@/types/dataType"
import { cloneDeep } from "lodash"
import { DataSource } from "@/types/dataSourceItem"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"
import { TenantFeatures } from "@/types/tenantFeatures"
import { TRANSITION_FOCUS_DELAY_MS } from "@/constants/animations"

@Component({
	components: {
		"v-select": vSelect,
		"parameter-value": ParameterValue,
		"help-icon": HelpIcon
	}
})
export default class DynamicParameters extends Vue {
	@Prop({ default: null })
	value!: DynamicParameter[] | null

	@Prop({ default: null })
	insight!: InsightDetails;

	@Prop({ default: () => [] })
	dataSources!: DataSource[]

	@Prop({ default: () => [] })
	includedParameters!: DynamicParameter[]

	@Prop({ default: () => [] })
	globalInsightParameters!: DynamicParameter[]

	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	parameterTypes = dataTypeParameters

	dataSourceType = DataType.array

	public get allValid (): boolean {
		return this.value
			? this.value.every(p => this.parameterNameValid(p.name))
			: true
	}

	get parameters (): DynamicParameter[] {
		return this.value
			? this.value.filter(v => !!v.key)
			: []
	}

	get parameterValueOptions () {
		return this.parameters.filter(p => !!p.key).toDictionaryMapValue(p => p.key, p => {
			return {
				operator: p.dataType === DataType.userRole
					? Operator.Contains
					: p.dataType === DataType.dateRange
						? Operator.DateRange
						: Operator.Equals,
				searchClauseParameters: null,
				fieldData: {
					fieldDataType: p.dataType === DataType.dateRange ? DataType.dateTime : p.dataType,
					dataSourceId: p.dataType === this.dataSourceType ? p.dataSourceId : null,
					dataType: p.dataType === DataType.userRole ? "user-role" : null
				}
			}
		})
	}

	@Watch("allValid")
	validChanged (nowValid: boolean) {
		this.$emit("validChanged", nowValid)
	}

	addParameter () {
		const value = cloneDeep(this.value) || []
		const newKey = Guid.newGuid()
		value.push({
			key: newKey,
			name: "",
			dataType: DataType.string,
			dataSourceId: null
		})

		this.$emit("input", value)

		this.$nextTick(() => {
			const dpNameInput =
				(this.$refs["dynamicParameterNameInput" + newKey] as Vue[])[0].$el as HTMLInputElement
			if (dpNameInput) dpNameInput.focus()
		})
	}

	removeParameter (parameter: DynamicParameter) {
		this.$emit("input", this.value!.filter(p => p.key !== parameter.key))
	}

	parameterNameValid (parameterName: string): boolean {
		return parameterName !== undefined && parameterName !== null && parameterName.length > 0 &&
			this.parameters.filter(p => p.name === parameterName).length < 2
	}

	clearDataSource (parameter: DynamicParameter, type: DataType) {
		if (type !== DataType.array) {
			parameter.dataSourceId = null
		}
	}

	includedParametersOfType (type: DataType): DynamicParameter[] {
		return this.includedParameters.filter(p => p.dataType === type)
	}

	private get closeOnSelect ():boolean {
		return !(this.getIsFeatureEnabled(TenantFeatures.MultiSelectKeepOpen))
	}

	typeChanged (parameter: DynamicParameter) {
		if (parameter.dataType !== null) {
			if (!this.getIsFeatureEnabled(TenantFeatures.DataEntryAutoFocus)) return
			setTimeout(() => {
				let defaultControl =
					(this.$refs["dynamicParameterDefault" + parameter.key] as ParameterValue[])[0]
						.$el.querySelector("input")
				if (defaultControl) defaultControl.focus()
			}, TRANSITION_FOCUS_DELAY_MS)
		}
	}
}

